module.exports = __webpack_public_path__ + "img/prize0.bdc8170.png";